import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "../Web-Developement-texas/index.css";
import "slick-carousel/slick/slick-theme.css";
import { style } from "framer-motion/client";



const technologies = [
  { name: "MySQL", icon: "/assets/mysql-logo.png" },
  { name: "PostgreSQL", icon: "/assets/postgresSql-logo.png" },
  { name: "SQL", icon: "/assets/sql-logo.png" },
  { name: "Python", icon: "/assets/python-logo.png" },
  { name: "WooCommerce", icon: "/assets/woocommerce-logo.png" },
  { name: "WordPress", icon: "/assets/wordpress-logo.png" },
  { name: "HTML5", icon: "/assets/html-logo.png" },
  { name: "Angular", icon: "/assets/angular-web-development.png" },
  { name: "Drupal", icon: "/assets/codeception-drupal-logo.png" },
  { name: "CSS3", icon: "/assets/css-logo.png" },
  { name: "Laravel", icon: "/assets/Laravel-logo.png" },
  { name: "Lambda", icon: "/assets/lambda-logo.png" },
  { name: "Joomla", icon: "/assets/joomla-logo.png" },
  { name: "Feather", icon: "/assets/feather-logo.png" },
  { name: "Blocks", icon: "/assets/blocks-logo.png" },
  { name: "Blocks 2", icon: "/assets/blocks2-logo.png" },
  { name: "aws", icon: "/assets/aws.png" },
  { name: "MongoDB", icon: "/assets/Magento.png" },
  { name: "PHP", icon: "/assets/php.png" },
  { name: "JavaScript", icon: "/assets/java.png" },
  { name: "TypeScript", icon: "/assets/typescript.png" },
  { name: "Magento", icon: "/assets/magento-slider-web-development.png" },
  { name: "Shopify / Shopify Plus", icon: "/assets/shopify.png" },
  { name: "Bigcommerce Development", icon: "/assets/big.png" },
  { name: "React", icon: "/assets/react.png" },
  { name: "Vue.js", icon: "/assets/Vue.png" },
  { name: "Bootstrap / Tailwind CSS", icon: "/assets/boot.png" },
  { name: "Node.js", icon: "/assets/node.svg" },
  { name: "Django", icon: "/assets/Django.svg" },
  { name: "Express.js", icon: "/assets/Express.png" },
  { name: "AWS (Amazon Web Services)", icon: "/assets/Amazon.png" },
  { name: "Docker", icon: "/assets/Docker.png" },
  { name: "Git / GitHub", icon: "/assets/git.png" },
  { name: "Adobe Creative Suite", icon: "/assets/Adobe.png" },
  { name: "Figma", icon: "/assets/Figma.png" },
  { name: "Canva", icon: "/assets/Canva.svg" },
  { name: "GitLab / Bitbucket", icon: "/assets/Gitlab.svg" },
  { name: "Jira / Trello", icon: "/assets/Trello.png" },
  { name: "Postman", icon: "/assets/Postman.svg" },
  { name: "Firebase", icon: "/assets/Firebase.png" },
];

const Section12 = () => {
  const settings = {
    infinite: true,
    speed: 1000,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToShow: 8,
    slidesToScroll: 5,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 12 } },
      { breakpoint: 850, settings: { slidesToShow: 5 } },
    ],
  };

  return (
    <div className="container-1280 pt-10 md:pt-[140px] mx-auto xl:min-w-[70%] lg:min-w-[90%] w-[90%] ">
      <div className="flex flex-col items-center text-center md:items-start md:text-start">
        <h2 className="text-[26px] md:text-[30px] font-bold text-red-600">Technologies We Use</h2>
        <p className="mt-2 text-gray-600">
          Our expert team combines experience and innovation to deliver
          cutting-edge web development solutions.
        </p>
        <p className="mt-1 text-gray-600">Your Privacy Is Our Priority.</p>
      </div>

      <div className="mt-6">
        <Slider {...settings}>
          {technologies.map((tech, index) => (
            <div key={index} className="p-3 min-w-max">
              <div className="flex items-center justify-center w-20 h-16 p-1 bg-white rounded-lg shadow-lg m-auto">
                <img src={tech.icon} alt={tech.name} className="max-w-[100%] h-[100%]" />
              </div>
                <p className="text-center mt-3">{tech.name}</p>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Section12;
